import Furniture from './Furniture';

export const SPEED = 50;

export default class Ant extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.setAnim('walk');

    this.anthill;

    this.homeX = this.x;
    this.homeY = this.y;
    this.entranceX = this.x - 45;
    this.entranceY = this.y;

    this.bb = new Phaser.Rectangle(0, 0, 30, 30);
  }

  init(x, y) {
    this.active = true;
    this.visible = true;
    this.goHome = false;
    this.isFull = false;
    this.inCorridor = true;
    this.x = x;
    this.y = y;
    this.dz = 0;

    this.asset.rotation = 0;
    this.rootBone.scaleX = 1;

    this.setSkin('normal');
  }

  setSkin(name) {
    const sx = this.rootBone.scaleX;
    const sy = this.rootBone.scaleY;
    this.asset.setSkinByName(name);
    this.asset.setToSetupPose();
    this.rootBone.scaleX = sx;
    this.rootBone.scaleY = sy;
  }

  setTarget(x, y, item = null, instantAngle = false) {
    if (!this.isFull) {
      this.targetX = x;
      this.targetY = y;
      this.targetItem = item;

      const dx = x - this.x;
      const dy = y - this.y;
      this.walkAngle = Math.atan2(dy, dx);

      if (Math.abs(this.walkAngle) > Math.PI / 2) {
        this.destRotation = (this.walkAngle < 0 ? -Math.PI : Math.PI) - this.walkAngle;
        if (instantAngle) {
          this.asset.rotation = this.destRotation;
        }
        this.rootBone.scaleX = 1;
      } else {
        this.destRotation = -this.walkAngle;
        if (instantAngle) {
          this.asset.rotation = this.destRotation;
        }
        this.rootBone.scaleX = -1;
      }
    }
  }

  /* eslint-disable max-statements */
  step(dt) {
    if (!this.active) {
      return;
    }

    super.step(dt);

    this.asset.rotation += (this.destRotation - this.asset.rotation) * 0.1;

    // movement in corridir
    if (this.inCorridor) {
      if (this.isFull) {
        // return home with food
        this.rootBone.scaleX = -1;
        this.x += dt * SPEED;
        if (this.x > this.homeX) {
          this.anthill.removeAnt(this);
        }
      } else {
        // go out
        this.asset.rotation = 0;
        this.rootBone.scaleX = 1;
        this.x -= dt * SPEED;
        if (this.x < this.entranceX) {
          this.inCorridor = false;
          this.setTarget(this.targetX, this.targetY, this.targetItem);
        }
      }
      return;
    }

    // walk
    this.x += dt * SPEED * Math.cos(this.walkAngle);
    this.y += dt * SPEED * Math.sin(this.walkAngle);

    // if target and overlap the target move ant over the target
    this.dz = 0;
    if (this.targetItem) {
      if (this.targetItem.drag || !this.targetItem.parent) {
        this.targetItem = null;
      } else {
        this.bb.x = this.x + this.location.x - this.bb.width * 0.5;
        this.bb.y = this.y - this.bb.height * 0.5;
        this.targetItem.updateBounds();
        if (Phaser.Rectangle.intersects(this.bb, this.targetItem.bb)) {
          this.dz = this.targetItem.bb.height + 8;
        }
      }
    }

    // check if reached target
    const dx = this.targetX - this.x;
    const dy = this.targetY - this.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 5) {
      if (!this.isFull) {
        // return home
        this.returnHome();
        this.isFull = true;
        this.setSkin('food');
      } else if (this.goHome) {
        // this.anthill.removeAnt(this);
        this.inCorridor = true;
        this.destRotation = 0;
      }
    }
  }
  /* eslint-enable */

  returnHome() {
    this.setTarget(this.entranceX, this.entranceY, this.targetItem, true);
    this.goHome = true;
  }

  removeAnt() {
    this.active = false;
    this.visible = false;
  }

  //
  serialize() {
    return null;
  }
}
